import AppointmentIcon from '../assets/analytics/appointmentIcon.svg';
import PatientIcon from '../assets/analytics/patientIcon.svg';
import OperationIcon from '../assets/analytics/operationIcon.svg';
import EarningIcon from '../assets/analytics/earningIcon.svg';
import UserImg from '../assets/other/user.png';
export const NavLinks = [
  {
    path: '/',
    name: 'Dashboard',
    dropdown: false,
    active: false,
  },
  {
    path: '/appointment',
    name: 'Appointments',
    dropdown: false,
    active: false,
  },
  {
    path: '/',
    name: 'Doctors',
    dropdown: false,
    active: false,
  },
  {
    path: '/',
    name: 'Departments',
    dropdown: false,
    active: false,
  },
  {
    path: '/',
    name: 'Patients',
    dropdown: false,
    active: false,
  },
  {
    path: '/',
    name: 'Payments',
    dropdown: false,
    active: false,
  },
  {
    path: '/',
    name: 'Service Pages',
    dropdown: false,
    active: false,
  },
  {
    path: '/',
    name: 'Help',
    dropdown: false,
    active: false,
  },
];

export const AnalyticsStats = [
  {
    title: 'Appointments',
    stats: '213',
    image: AppointmentIcon,
  },
  {
    title: 'New Patients',
    stats: '104',
    image: PatientIcon,
  },
  {
    title: 'Operations',
    stats: '24',
    image: OperationIcon,
  },
  {
    title: 'Hospital Earnings',
    stats: '$ 12,174',
    image: EarningIcon,
  },
];

export const Appointment = [
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Ayesha Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Sana Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Mahnoor Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Laila Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Faha Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Saba Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Asad Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Saba Asad',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Leslie Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
  {
    doctorId: 1,
    userimg: UserImg,
    name: 'Leslie Alexander',
    email: 'lesie.alexander@example.com',
    date: '10/10/2020',
    visitTime: '09:15-09:45am',
    doctor: 'Dr. Jacob Jones',
    condition: 'Mumps Stage II',
  },
];
